<ng-template #content let-modal>
	<div class="modal-header" style="  background: linear-gradient(to bottom, #F9F9FC 0%, #EEEEF4 100%);    height: 50px;
  width: 720;">
		<h4 class="modal-title" id="modal-basic-title" style="font-size: 16px;
      font-weight: 500;">
			Download
		</h4>
		<button type="button" class="close" aria-label="Close" (click)="closeModal()"> <span aria-hidden="true">
				&times;
			</span> </button>
	</div>
	<div class="modal-body" style="        padding: 40px">
        <p *ngIf="saveFileText2" class="text-left px-3" id="saveFileText2" style="color: red"> <i
            class="fa fa-times-circle" id="saveFileText2" style="font-size: 14px"></i> {{ saveFileText2 }} </p>
        <h5 style="text-align: center;    font-size: 16px;
                      font-weight: 500;color: #000000;" class="mb-4">Select your format</h5>
        <form class="justify-content-center pb-5" style="text-align: center">
         <div class="btns-div">
			<button class=" pdf"  (click)="downloadPdf3()" >
			
					<app-icons-free-tools [name]="'pdfFileDownloadIcon'" />
				 <span style="
				 font-size: 18px;
				 font-weight: 500;
				 line-height: 21.78px;
				 text-align: left;"> Download PDF</span>
			  </button>
			  <button class="doc" (click)="downloadWordDocument()">
		
					<app-icons-free-tools [name]="'docFileDownloadIcon'" />
				 <span style="
				 font-size: 18px;
				 font-weight: 500;
				 line-height: 21.78px;
				 text-align: left;"> Download Document</span>
			  </button>
		 </div>
        </form>
      </div>	
</ng-template>
<button class="btn btn-lg btn-outline-primary d-none" (click)="openModels(content)"> Download </button>